import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { CityReqDTO, CitySearchCriteriaRes } from 'src/models/city';
import { tourismClassifiedAPIRoutes } from '..';

// Define a service using a base URL and expected endpoints
/**
 * cityServices is a collection of API endpoints for city.
 */
export const cityServices = createApi({
  reducerPath: 'cityServices',
  tagTypes: ['CityServicesTag'],
  baseQuery: fetchBaseQuery({
    baseUrl: tourismClassifiedAPIRoutes.baseUrl,

    prepareHeaders: (headers) => {
      const token = localStorage.getItem('jwtToken');
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    }
  }),

  endpoints: (builder) => ({
    getAllCities: builder.mutation<CitySearchCriteriaRes, CityReqDTO>({
      query: (body) => ({
        url: `${tourismClassifiedAPIRoutes.city.endpoint}/${tourismClassifiedAPIRoutes.city.getAllCities}`,
        method: 'POST',
        body
      }),
      invalidatesTags: ['CityServicesTag']
    }),

    addCityData: builder.mutation({
      query: (body) => ({
        url: `${tourismClassifiedAPIRoutes.city.endpoint}/${tourismClassifiedAPIRoutes.city.addCityData}`,
        method: 'POST',
        body
      }),
      invalidatesTags: ['CityServicesTag']
    }),

    updateCityData: builder.mutation({
      query: (body) => ({
        url: `${tourismClassifiedAPIRoutes.city.endpoint}/${tourismClassifiedAPIRoutes.city.updateCityData}`,
        method: 'PUT',
        body
      }),
      invalidatesTags: ['CityServicesTag']
    }),

    deleteCityData: builder.mutation<any, any>({
      query: (body) => ({
        url: `${tourismClassifiedAPIRoutes.city.endpoint}/${tourismClassifiedAPIRoutes.city.deleteCityData}`,
        method: 'DELETE',
        body
      }),
      invalidatesTags: ['CityServicesTag']
    }),

    uploadCityImage: builder.mutation<any, FormData>({
      query: (body) => ({
        url: `${tourismClassifiedAPIRoutes.city.endpoint}/uploadCityImage`,
        method: 'POST',
        body
      })
    }),

    getAllCountries: builder.query<any[], void>({
      query: () => ({
        url: `${tourismClassifiedAPIRoutes.city.endpoint}/getAllCountries`,
        method: 'GET'
      }),
      providesTags: ['CityServicesTag']
    })
  })
});

export const {
  useGetAllCitiesMutation,
  useAddCityDataMutation,
  useUpdateCityDataMutation,
  useDeleteCityDataMutation,
  useUploadCityImageMutation,
  useGetAllCountriesQuery
} = cityServices;

